import React, { useEffect, useRef } from 'react';
import { Row, Col } from 'antd';

import { Title } from '@/components/Typography';
import { useOWASContext } from '../../../../context';
import { CardScore } from '../../../../components/CardScore';
import { useGetOwasFrameResult } from '../../../../hooks/useGetOwasFrameResult';
import { DividerWrapper } from './Result/styles';

interface HeaderProps {
	id: string;
	title: string;
	isOpen: boolean;
}

export function Header({ id, title, isOpen }: Readonly<HeaderProps>): JSX.Element {
	const { parameters, data } = useOWASContext();
	const headerRef = useRef() as React.MutableRefObject<HTMLDivElement>;

	const { data: result } = useGetOwasFrameResult({
		organization_id: parameters?.organization_id!,
		company_id: parameters?.company_id!,
		file_id: parameters?.file_id!,
		report_id: data?.id!,
		frame_id: id
	});

	const code = result?.code ?? '-';

	useEffect(() => {
		if (isOpen) {
			setTimeout(() => {
				headerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
			}, 300);
		}
	}, [isOpen]);

	return (
		<Row justify="space-between" align="middle">
			<Col span={24}>
				<div ref={headerRef} style={{ marginTop: -30, width: 0, height: 0 }} />
			</Col>
			<Col span={12}>
				<Title level={5} style={{ margin: 0 }}>
					{title}
				</Title>
			</Col>
			{!isOpen && (
				<Col lg={9} xxl={6}>
					<Row justify="end" gutter={[20, 0]}>
						<Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							<Title level={5} style={{ margin: 0 }}>
								{code}
							</Title>
						</Col>
						<Col span={2} style={{ display: 'flex', justifyContent: 'center' }}>
							<DividerWrapper type="vertical" />
						</Col>
						<Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
							<CardScore score={result?.score} fontSize="1rem" />
						</Col>
					</Row>
				</Col>
			)}
		</Row>
	);
}
